import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { Text } from 'react-native';
import * as RNStyle from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var Title = function Title(props) {
  var content = props.content,
    maxLines = props.maxLines,
    stylesProp = props.styles;
  return /*#__PURE__*/React.createElement(Text, {
    style: [styles.title, stylesProp],
    numberOfLines: maxLines
  }, content);
};
var styles = CustomStyleSheet({
  // .@{prefix-cls}-title {
  //   line-height: 1.25rem;
  //   font-weight: 500;
  //   font-size: 1rem;
  //   color: @gray-1;
  // }
  // each(range(5), {
  //   .@{prefix-cls}-title-ellipsis-@{value} {
  //     .ellipsis-text(@value);
  //   }
  // });
  title: _objectSpread(_objectSpread({
    lineHeight: 20
  }, RNStyle.FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 16,
    color: RNStyle.gray_1
  })
});